<template>
  <div class="app-sim-success">
    <div class="top-wrapper">
    </div>
    <div class="outer-wrapper">
      <slot v-if="this.isEsim" name="ceSubstituteESim"></slot>
      <slot v-else-if="this.isPreActivated"  name="ceSubstituteSimActive"></slot>
      <slot v-else  name="ceSubstituteSimInactive"></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import useFeature from '@/mixins/useFeature'
import { substituteSimTracking } from '@/helper/checkoutTracking'

export default {
  name: 'SubstituteSimSuccess',
  props: {
    isEsim: {
      type: Boolean,
      default: true
    }
  },
  mixins: [
    useFeature('showSubstituteSimV2')
  ],
  mounted () {
    this.triggerConfirmTracking('success')
  },
  computed: {
    ...mapGetters('substituteSimCard', [
      'getSelectionData', 'getSimCardOption', 'isPreActivated', 'getOrderId'
    ]),
    isPreActivated: function () {
      if (this.showSubstituteSimV2) {
        return this.$store.getters['checkoutv2/substituteSim/activated']
      } else {
        return this.$store.getters['substituteSimCard/isPreActivated']
      }
    },
    isSimActive: function () {
      return this.isPreActivated || this.isEsim
    }
  },
  methods: {
    triggerConfirmTracking (confirmStatus) {
      if (this.showSubstituteSimV2) {
        substituteSimTracking(this.$store, 3)
      } else {
        let propositions = ''
        if (typeof window.trackingNS?.track?.getSimSwapPropositions === 'function') {
          propositions = window.trackingNS.track.getSimSwapPropositions(this.getSimCardOption, this.getSelectionData)
        }
        const data = {
          page_levels: [
            'mein-simon',
            'meine-sim',
            'sim replacement',
            'confirmation'
          ],
          login_status: 'not logged in', // check/set in tracking
          page_type: 'self service',
          platform_type: 'browser view',
          form: {
            name: 'sim replacement',
            step_name: 'confirmation',
            step: '3',
            type: 'order funnel',
            status: confirmStatus
          },
          order_id: this.getOrderId,
          payment_method_once: 'lastschrift',
          activation_method: this.getSelectionData.activation,
          shipping_price: this.getSimCardOption.shippingCosts,
          propositions: propositions
        }
        if (typeof window.trackingNS?.track?.tracking === 'function') {
          window.trackingNS.track.tracking('pageview', data)
        }
      }
    }
  }
}
</script>
